export default "__VITE_PUBLIC_ASSET__2ad4ce21__"